<template>
  <div id="integration-modal" class="editor-modal">
    <h2>{{ $t("create-int.title") }}</h2>
    <radio-button
      lightLabel
      :listClasses="'radio-btns'"
      v-model="integrationType"
      :label="$t('create-int.type-desc')"
      :options="radioButtonOptions"
    />
    <div v-if="integrationType === 'connector'">
      <ConnectorIntegrationForm @onSave="createFixed" @close="$emit('close')" />
    </div>
    <div v-else>
      <DefaultIntegrationForm
        :integrationType="integrationType"
        @onSave="createCustomContentSource"
        @close="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import ConnectorIntegrationForm from "@/components/integrations/ConnectorIntegrationForm";
import DefaultIntegrationForm from "@/components/integrations/DefaultIntegrationForm";
import ConfirmModal from "@/components/modals/ConfirmModal";
import RadioButton from "@/components/RadioButton";
export default {
  props: {
    contentSources: Array,
    currentType: Object,
    onCreateCustomIntegration: Function,
    onCreateFixed: Function,
  },
  data() {
    return {
      integrationType: "connector",
      fixed: {
        enumName: "Shopify",
        config: {
          APIKey: "",
          APIPassword: "",
          URL: "",
          OptIn: true,
        },
      },
      radioButtonOptions: [
        { value: "connector", name: "connector", label: "Connector" },
        {
          value: "endpoints",
          name: "Endpoints",
          label: "Endpoints",
        },
        {
          value: "testdata",
          name: "TestData",
          label: "Test data",
        },
      ],
    };
  },

  methods: {
    createFixed(source) {
      this.onCreateFixed(source);
      this.$emit("close");
    },
    createCustomContentSource(source) {
      let findDuplicate = this.$store.state.contentTypes.find(
        (c) => c.name.toLowerCase() === source.name.toLowerCase()
      );
      console.log(findDuplicate);
    //   if (this.integrationType == 'endpoints') {
    //       this.source.dummy = false;
    //   }
      if (findDuplicate) {
        this.$modal.show(
          ConfirmModal,
          {
            title: this.$t("data.duplicate-title"),
            description: this.$t("data.duplicate-desc"),
            hideCancelButton: true,
          },
          { width: 350, height: "auto" }
        );
      } else {
        console.log(source);
        this.onCreateCustomIntegration(source);
        this.$emit("close");
      }
    },
  },
  computed: {
    valid() {
      //  if(this.dataPicked === 'dummy'){return this.dummySource.name }
      //  else {return this.customSource.name }
      //    if(this.dataPicked === 'dummy'){return this.dummySource.name }
      //    else if(this.dataPicked === 'fixed') {return this.fixed.name }
      //    else {return this.customSource.name }
      return true;
    },
  },

  components: {
    ConnectorIntegrationForm,
    DefaultIntegrationForm,
    RadioButton,
  },
};
</script>

<style lang="less">
#integration-modal {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }
  .footer {
    margin-top: 10px;
  }
  .radio-btns {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr !important;
    padding-top: 12px;
  }
}
</style>